import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useEffect, useState } from "react";
import { EmailForm } from "./EmailForm";
import { OtpForm } from "./OtpForm";
import { ThemeToggle } from "@/components/theme/ThemeToggle";
import { LanguageSelector } from "@/components/LanguageSelector";
import { useTranslation } from "react-i18next";
import { useAppNavigate } from "@/hooks/useAppNavigate";

export const LoginPage = () => {
  const { t } = useTranslation();
  const { goToForgotPassword } = useAppNavigate();
  const [loginStep, setLoginStep] = useState<"email" | "otp">("email");
  const [toEmail, setToEmail] = useState<string>();

  useEffect(() => {
    document.title = `${t("login.title")} - Corevo Live`;
  }, [t]);

  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-muted p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-4xl">
        <div className="flex flex-col gap-6">
          <Card className="overflow-hidden">
            <CardContent className="grid p-0 md:grid-cols-2">
              <div className="flex flex-col p-6 md:p-8">
                <CardHeader className="pl-0">
                  <CardTitle className="text-2xl">{t("login.title")}</CardTitle>
                </CardHeader>
                {loginStep === "email" && (
                  <EmailForm
                    onOtpSent={(toEmail) => {
                      setLoginStep("otp");
                      setToEmail(toEmail);
                    }}
                  />
                )}
                {loginStep === "otp" && toEmail && <OtpForm email={toEmail} />}
                <div
                  className="mt-4 text-center text-sm underline border-t mt-8 pt-8 cursor-pointer"
                  onClick={goToForgotPassword}
                >
                  {t("login.lostPassword")}
                </div>
                <div className="flex justify-center mt-4 gap-2">
                  <ThemeToggle />
                  <LanguageSelector />
                </div>
                <div className="flex justify-center items-center mt-4">
                  <img src="/logo.svg" alt="Logo" className="h-[50px] object-contain mt-4" />
                </div>
              </div>
              <div className="relative hidden bg-muted md:block">
                <img
                  src="/login1.png"
                  alt="Image"
                  className="absolute inset-0 h-full w-full object-cover dark:grayscale"
                />
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};
